import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {CheckboxChangeEvent} from '@pluto/@types';
import {
    ContentPartnerStatusEnum,
    ContentPartnersFiltersType,
} from './ContentPartnersTypes';
import './ContentPartnersFilters.scss';

interface ContentPartnersFiltersProps {
    onStatusFilter: CheckboxChangeEvent;
    filters: ContentPartnersFiltersType;
}

export default function UserFiltersList(props: ContentPartnersFiltersProps) {
    const {onStatusFilter, filters} = props;

    return (
        <Box className="content-partners__filters">
            <FormControl component="div" className="content-partners__filters__line">
                <Typography variant="body1">Status:</Typography>
                <FormGroup className="content-partners__filters__line__checkboxes">
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={ContentPartnerStatusEnum.Active}
                                checked={filters.active?.includes(
                                    ContentPartnerStatusEnum.Active
                                )}
                            />
                        }
                        label="Active"
                        onChange={onStatusFilter}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={ContentPartnerStatusEnum.Inactive}
                                checked={filters.active?.includes(
                                    ContentPartnerStatusEnum.Inactive
                                )}
                            />
                        }
                        label="Deactivated"
                        onChange={onStatusFilter}
                    />
                </FormGroup>
            </FormControl>
        </Box>
    );
}
